module.exports = {
  NODE_ENV: process.env.NODE_ENV,
  BASE_URL: process.env.REACT_APP_BASE_URL,
  BASE_ROOT_URL: process.env.REACT_APP_BASE_ROOT_URL,
  BASE_ADMIN_URL: process.env.REACT_APP_BASE_ADMIN_URL,
  API_KEY: process.env.REACT_APP_API_KEY,
  LINE_ID: process.env.REACT_APP_LINE_ID,
  TEST_ENV_CONFIGMAP: process.env.TEST_ENV_CONFIGMAP,
  TEST_ENV_SECRET: process.env.TEST_ENV_SECRET,
  LIMIT_SESSION_TIMEOUT: 60 * 60, // 60 * 30 = 30 minutes
  PERMISSIONS: {
    TYPES: {
      ADMIN: "admin",
      USER: "user",
      SELLER: "seller",
    },
  },

  // PDPA
  ONETRUST_TERMS_OF_USE_URL: process.env.REACT_APP_ONETRUST_TERMS_OF_USE,
  ONETRUST_PRIVACY_POLICY_URL: process.env.REACT_APP_ONETRUST_PRIVACY_POLICY,
  ONETRUST_COOKIES_NOTICE_URL: process.env.REACT_APP_ONETRUST_COOKIES_NOTICE,
  ONETRUST_API_URL: process.env.REACT_APP_ONETRUST_API_URL,

  //ONETRUST_PRIVACY
  ONETRUST_PRIVACY: {
    TOKEN: process.env.REACT_APP_ONETRUST_PRIVACY_TOKEN,
    ID: process.env.REACT_APP_ONETRUST_PRIVACY_ID,
  },

  //ONETRUST_PDPA
  ONETRUST_PDPA: {
    TOKEN: process.env.REACT_APP_ONETRUST_PDPA_TOKEN,
    ID: process.env.REACT_APP_ONETRUST_PDPA_ID,
  },

  //ONETRST_TERMS
  ONETRUST_TERMS: {
    TOKEN: process.env.REACT_APP_ONETRUST_TERMS_TOKEN,
    ID: process.env.REACT_APP_ONETRUST_TERMS_ID,
  },

  //ONETRUST_SHARED_DATA
  ONETRUST_SHARED_DATA: {
    TOKEN: process.env.REACT_APP_ONETRUST_SHARED_DATA_TOKEN,
    ID: process.env.REACT_APP_ONETRUST_SHARED_DATA_ID,
  },

  // DEFAULT_PRODUCT_URL
  DEFAULT_PRODUCT_URL: process.env.REACT_APP_DEFAULT_PRODUCT_URL,

  LINE_LIFF_ID: process.env.REACT_APP_LINE_LIFF_ID,
};
